@if (listJson) {
  <div class="package-conatiner">
    <!--  <app-title [options]="titleOptions" (backEvent)="backClick($event)" (actionEvent)="actionClick($event)"></app-title>   -->
    <div class="list-container" [ngClass]="arrSelectedInventoryId.length > 0 ? 'margin-present': ''">
      <div class="list-header">
        <!-- <mat-checkbox class="base-check-box checkbox-class" [(ngModel)]="allCheckBox" (change)="addInArray($event,'','all')"></mat-checkbox>  -->
        <app-checkbox class="checkbox-class" [customCBxDisabled]="allCBxDisable" [customCBxChecked]="allCheckBox"  (changeEvent)="addInArray($event,'','all')"></app-checkbox>
        <span class="item-name">{{'Requisition.packageSelection' | translate}}</span>
        <span class="quantity">{{listJson.length}} {{'items.items' | translate}}</span>
      </div>
      @if (listJson.length > 0) {
        <div id="cdk-view_port" #scrollcontainer  class="showNoDataFullScreen con-scroll-inner-container"   (scroll)="fetchMore($event)">
          <div class="list-row-parent" #rowParent>
            @if (!showNodata) {
              <div>
                @for (item of listJson; track item) {
                  <div class="list-row" >
                    <!-- <mat-checkbox class="base-check-box checkbox-class" [checked]="item.selected" (change)="addInArray($event,item,'one')"></mat-checkbox> -->
                    <app-checkbox class="checkbox-class" [customCBxChecked]="item.selected"  (changeEvent)="addInArray($event,item,'one')"></app-checkbox>
                    <div class="list-structure">
                      <div class="first-row">
                        <span class="item-name">{{item.Name}}</span>
                        <span class="quantity">{{item.QuantityonHandForAllLocs | decimalFormatter}}</span>
                      </div>
                      <div class="second-row">
                        <span class="item-code">#{{item.Number}} </span>
                        @if (!_commonService.isonlineStatus) {
                          @for (unit of item.UnitsDetails; track unit) {
                            @if (unit.UnitCode && unit.UnitTypeId==baseUnitTypeId) {
                              <span class="unit text-capitalize">{{unit.UnitCode}}</span>
                            }
                          }
                        }
                        @if (_commonService.isonlineStatus) {
                          <!-- <span class="unit text-capitalize" *ngIf="unit.UnitCode && unit.UnitTypeId==baseUnitTypeId">{{unit.UnitCode}}</span> -->
                          <span class="unit text-capitalize" >{{item.BaseUnitCode}}</span>
                          }                <!-- <span class="unit" *ngFor="let unit of item.UnitsDetails">
                          <label *ngIf="unit.UnitCode && unit.UnitTypeId==baseUnitTypeId">{{unit.UnitCode| lowercase}}</label>
                        </span> -->
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (showNodata) {
        <app-no-items [class]="'landing-no-data'"></app-no-items>
      }
    <!-- </virtual-scroller>  -->
  </div>
  <div class='popOver'>
    <app-bottom-pop-over [add]='true' [suggest] = 'false' [delete]="false" [count]='arrSelectedInventoryId.length' (AddItems)="addInList()" (ClosePopOver)='closePopOver($event)'></app-bottom-pop-over>
  </div>
</div>
}